import { NavigatorQuery } from '../graphql/queries/Navigator/query';

export type AppliedPolicy = NavigatorQuery['lifeApplication']['policies']['appliedPolicy'];

export const hasEditRestrictedAUAppliedPolicy = (appliedPolicy?: AppliedPolicy) =>
  !!(
    appliedPolicy?.policyNumber &&
    appliedPolicy?.issueType === 'accelerated_underwriting' &&
    (appliedPolicy?.carrier?.slug === 'brighthouse' ||
      appliedPolicy?.carrier?.slug === 'lincoln-national-life')
  );
